import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';

interface Props {
  onClear: () => void;
}

export const ClearFilters = ({ onClear }: Props) => {
  const intl = useIntl();

  return (
    <Button
      text={intl.formatMessage({
        id: 'ClearFilters.clearFiltersText',
        defaultMessage: 'Clear Filters',
        description: 'Button text to clear all filters',
      })}
      variant="action"
      onClick={onClear}
    />
  );
};
